import { render, staticRenderFns } from "./BiographyBuilderContentSection.vue?vue&type=template&id=49d5b93e&scoped=true&"
import script from "./BiographyBuilderContentSection.vue?vue&type=script&lang=js&"
export * from "./BiographyBuilderContentSection.vue?vue&type=script&lang=js&"
import style0 from "./BiographyBuilderContentSection.vue?vue&type=style&index=0&id=49d5b93e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d5b93e",
  null
  
)

component.options.__file = "BiographyBuilderContentSection.vue"
export default component.exports